module.exports = __webpack_public_path__ + "img/torn.71163f80.svg";